import type { BlockSkill } from '../../../battle/types';
import type { SkillBundle } from '../../types';

const ROOT = '/assets/textures/characters/sparky_bot/block';

const ENGINE: BlockSkill = {
  kind: 'block',
  id: 'sparky_bunker',
  name: 'Bunker',
  triggerChance: 0.4,        // 40% base; +luck*LUCK_COEF at runtime
  blockEffectiveness: 1,     // 100% absorbed - bunker fully nullifies the hit
  counterChance: 0,          // no block-counter yet
  animationId: 'block',      // reuses default block animation
};

// Engine-only skill - no custom render hook. Defender's default block stance
// (sparky's `block` anim, auto-synced to attacker's punch impact) handles the
// visual already.
export const SPARKY_BUNKER: SkillBundle = {
  engine: ENGINE,
  // Shown under the UI-log "BLOCKED" label. Reserved key: logIcon.
  assets: {
    textures: {
      logIcon: `${ROOT}/ui-log-icon.png`,
    },
  },
};
